let connection = 'https://service.fb-c.at'
if (process.env.NODE_ENV === 'development') {
    connection = 'https://localhost:32768';
  } else {
    connection = 'https://service.fb-c.at';
  }
export{connection}